import React from "react";
import Pill from "../../ui/atoms/Pill";

interface ActionPillProps {
  value: string;
}

const ActionPill: React.FC<ActionPillProps> = ({ value }) => {
  return <Pill className="action-pill">{value}</Pill>;
};

export default ActionPill;
